const E = {
  100: "#F9F7FD",
  200: "#F3EEFD",
  300: "#DBD0FE",
  400: "#C3B2FF",
  600: "#8559EC",
  700: "#714BD6",
  800: "#6C30D1",
  900: "#5627B0"
}, s = {
  100: "#F8F9FA",
  200: "#F2F3F6",
  300: "#E9EBEF",
  400: "#D1D3DB",
  500: "#AEAFBD",
  600: "#6A6E7A",
  700: "#42454B",
  800: "#242427",
  900: "#121212"
}, c = {
  100: "#ECF3FB",
  700: "#107EE6",
  800: "#0E6EC8"
}, D = {
  100: "#FFEDED",
  200: "#FFDEE0",
  400: "#FD979D",
  700: "#E8373F",
  800: "#E52029",
  900: "#C71119"
}, a = {
  100: "#F2FBF8",
  700: "#04B675",
  800: "#00AD6E",
  900: "#008051"
}, l = {
  200: "#F7F3EB",
  600: "#FFC453",
  900: "#886A2F"
}, d = {
  black: "#000000",
  "gray-900": "#121212",
  purple: "#A578FF",
  red: "#E82953",
  pink: "#FFB9C6",
  peach: "#FFD7D5",
  blue: "#7595E6",
  green: "#40C8A4",
  yellow: "#FFD083",
  "yellow-200": "#F7F3EB",
  cream: "#F7F3EB",
  white: "#FFFFFF",
  /**
   * Brand purple gradient (Figma: Brand/brand-gradient-1).
   * Applied at top-left → bottom-right (135deg).
   */
  "gradient-1": "linear-gradient(135deg, #6C30D1 0%, #A930D1 100%)"
}, B = {
  white: "#FFFFFF",
  black: "#000000"
}, g = {
  dark: "rgba(18, 18, 18, 0.6)"
}, i = {
  base: B,
  purple: E,
  gray: s,
  blue: c,
  red: D,
  green: a,
  yellow: l,
  brand: d,
  overlay: g
}, o = (F) => /^(linear-gradient|radial-gradient|conic-gradient)\(/.test(F.trim()), C = Object.entries(i).reduce((F, [r, t]) => (Object.entries(t).forEach(([n, e]) => {
  typeof e == "string" && o(e) || (F[`${r}-${n}`] = e);
}), F), {}), b = Object.entries(i).reduce((F, [r, t]) => (Object.entries(t).forEach(([n, e]) => {
  typeof e != "string" || !o(e) || (F[`${r}-${n}`] = e);
}), F), {});
export {
  i as AllColors,
  C as ColorPrimitives,
  b as GradientPrimitives,
  B as base,
  c as blue,
  d as brand,
  s as gray,
  a as green,
  o as isColorGradient,
  g as overlay,
  E as purple,
  D as red,
  l as yellow
};
//# sourceMappingURL=index.js.map
